import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { MoreBtn } from '../CommonBtn/MoreBtn';
import { Header } from '../IndexPage/Header/Header';
import { HerosectionsAll } from '../HeroSectionAll/HerosectionsAll';
import { Footer } from '../Footer/Footer';


export const AllOurTeam = () => {

    return (
        <>
 <div className="container-fluid">
            <div className="row " onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="AllOurTeam"  subactive="About" />
                    <HerosectionsAll ScreenName="Our Team" ScreenSearch="AllOurTeam" />

                    <div className="row col-lg-112 p-lg-5 my-5 rounded mx-auto py-5" >
                        <div className="col-12 text-center pb-5">
                            <h3 className="fw-bold text-dark ">Our Team</h3>

                            <div className="col-6 col-lg-2 mx-auto zoom-in-out-box2 text-center">
                                <hr />
                            </div>
                        </div>
                        <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center bounce" id="hover_effect">
                            <img src="Static/Assets/Img/img_avatar2.png" className="Team" alt="" />
                        </div>

                        <div className="col-12 col-lg-9 ">
                            <div className="pt-4 pb-1 bg_color3 " style={{ background: '#0d2f42' }}>
                                <h5 className="fw-bold pb-3"> A.W.J. (Tony) Fernandez </h5>
                                <p> Risk Management Consultant, Consulting Average Adjuster & Learning Facilitator. </p>
                                <p> Chief Instructor & Shipwright (Indian Navy-1965-1971). </p>
                                <p> Hon. Fellow International Institute of Marine Surveying (UK). </p>
                                <p> Maritime Operational Risk Management Advisor, Mediator & Arbitrator. </p>
                                <p> Associate Member Association of Average Adjusters of the United States & Canada. </p>
                                <p> Visiting Professor Maritime Law & Insurance Law - Gujarat National Law University. </p>
                                <p> Course Leader – PGD, Marine Insurance Law & Practice - World Maritime University, Sweden. </p>
                            </div>
                        </div>

                        <div className="col-12 col-lg-2 pt-5 d-flex justify-content-center align-items-center bounce" id="hover_effect">
                            <img src="Static/Assets/Img/img_avatar2.png" className="Team3" alt="" />
                        </div>

                        <div className="col-12 col-lg-9 pt-lg-5">
                            <div className="pt-4 pb-1 bg_color3" >
                                <h5 className="fw-bold pb-3"> Mrs. Anuradha More </h5>
                                <p> Associate Member of Association of Average Adjuster- UK. </p>
                                <p> Member of Chartered Insurance Institute of London- Dip-CII. </p>
                                <p> Fellow Member of Insurance Institute of India- FIII. </p>
                                <p> M Com, Bachelor of Law (LL.B) - University of Mumbai. </p>
                                <p> Ex-employee - 25 years at United India Insurance Company Ltd.(Govt. Undertaking ). </p>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>
        </>
    )
}
